import React, { useState, useEffect } from "react";
import "./Home.css";
import img1 from '../../Assets/home1.jpg'
import img2 from "../../Assets/home2.jpg";
import img3 from "../../Assets/home3.JPG";
import img4 from "../../Assets/home4.jpg";
import quotation from '../../Assets/quotation.png'
import Enquiry from "../Enquiry/Enquiry"
import info1 from "../../Assets/info1.jpg"
import info2 from '../../Assets/info2.jpg'
import info3 from '../../Assets/info3.jpg'

const images = [img1, img2, img3, img4];

const testimonials = [
  {
    text: "Our child's academic growth has been remarkable since joining this school."
    
  },
  {
    text:  "We've seen our child grow into a compassionate and capable individual."

    
  },
  {
    text: "The school fosters a great learning environment with excellent faculty and engaging activities."
   
  },
  {
    text: "Our child has found a sense of belonging at this school."

  },
];

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="Home-Container">
      <div className="slideshow-container">
        <div className="arrow left" onClick={prevSlide}>
          &#10094;
        </div>
        <div className="slideshow">
          <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />
        </div>
        <div className="arrow right" onClick={nextSlide}>
          &#10095;
        </div>
        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            ></span>
          ))}
        </div>
      </div>

      <div className="info-card">
        <div className="info-card-1">
          <div className="card-text">
            <h2 style={{textAlign:"center"}}>Welcome to V.D. Prasada Rao Memorial High School</h2>
            <p>At V.D. Prasada Rao Memorial High School, we believe in shaping the future by nurturing young minds today. Sponsored by the V.D. Prasada Rao Educational Society, our school is dedicated to providing quality education that goes beyond textbooks. With a strong emphasis on character building, discipline, and holistic development, we aim to prepare students for a successful and fulfilling future.
Located in Sri Rama Krishna Puram, our school serves the surrounding communities, offering a well-rounded curriculum designed to foster intellectual, emotional, and social growth. Under the leadership of experienced educators and professionals, we create an environment where every student is encouraged to explore, learn, and develop to their full potential.
            </p>
          </div>
          <div className="card-image">
            <img src={info3} alt="Info Card" />
          </div>
        </div>

        <div className="info-card-2">
          <div className="card-text">
            <h2>Overview</h2>
            <p>
            The faculty at V D PRASADA RAO MEMORIAL HIGH SCHOOL are highly qualified and experienced educators, dedicated to excellence in teaching. 
             Many hold advanced degrees and participate in ongoing professional development to stay at the forefront of educational best practices. 
              Our support staff also play a vital role, ensuring the smooth operation of the school and providing a safe and welcoming environment for all.
            </p>
          </div>
          <div className="card-image">
            <img src={img3} alt="Info Card" />
          </div>
        </div>
        <div className="info-card-1">
          <div className="card-text">
            <h2>Why Choose Us?</h2>
            <ul>
      <li>Holistic Education: We provide not just academic learning but also focus on physical, moral, and aesthetic development.</li>
      <li>Experienced Faculty: Our staff, including lecturers and professionals, are committed to bringing out the best in every student.</li>
      <li>Disciplined Environment: Discipline and good habits are at the heart of our approach to education, ensuring students learn and grow with responsibility and respect.</li>
      <li>Leadership Opportunities: We encourage students to take on leadership roles and participate in various activities to build character and confidence.</li>
    </ul>
          </div>
          <div className="card-image">
            <img src={info1} alt="Info Card" className="card-image-css" />
          </div>
        </div>
        <div className="info-card-2">
          <div className="card-text">
            <h2>Management</h2>
            <p>
            The school is managed by the V.D. Prasada Rao Educational Society, which is committed to fostering a culture of excellence in education. The management works closely with the faculty and administration to ensure the overall development of each student. With experienced leadership and dedicated staff, we ensure that our students receive the best opportunities for growth in both their academic and extracurricular endeavors.

The final authority for admissions and other key decisions lies with the Correspondent, ensuring that the process remains transparent, fair, and in the best interests of the students.


            </p>
          </div>
          <div className="card-image">
            <img src={info2} alt="Info Card" />
          </div>
        </div>
      </div>

      <div className="testimonial-container">
        <h2 className="testimonial-title">
          <span className="highlight">Parent Say</span> About Us
        </h2>
        <div className="testimonial-slide">
  <img className="testimonial-quotation left" src={quotation} alt="Quotation" />
  <p className="testimonial-text">{testimonials[testimonialIndex].text}</p>
  <img className="testimonial-quotation right" src={quotation} alt="Quotation" />
</div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`dot ${testimonialIndex === index ? "active" : ""}`}
              onClick={() => setTestimonialIndex(index)}
            ></span>
          ))}
        </div>
      </div>
      <Enquiry className="Home-enquiry" />
    </div>
  );
}

export default Home;
                                                                                      